import { Tag, TTagVariant } from "@/components/elements/Tag";
import { background, black, labelColor } from "@/theme/colors";
import { LEARNER_PLAN_STATUS, TLearnerPlanStatus, LEARNER_PLAN_STATUS_LABEL } from "@/types/enum";

import { FC, useMemo } from "react";

export type TLearnerStatusTagProps = {
  planStatus: string;
  variant?: TTagVariant;
  minWidth?: string;
};

export const LearnerStatusTag: FC<TLearnerStatusTagProps> = ({ planStatus, variant = "bold", minWidth }) => {
  const commonStyleText = { "& .MuiTypography-root": { color: black[30], fontWeight: "400" } };

  type StatusConfig = { color: string; sx?: object };

  const STATUS_CONFIG: Record<TLearnerPlanStatus, StatusConfig> = {
    [LEARNER_PLAN_STATUS.PREPARING]: { color: labelColor.disable, sx: commonStyleText },
    [LEARNER_PLAN_STATUS.STUDYING]: { color: labelColor.progress, sx: commonStyleText },
    [LEARNER_PLAN_STATUS.EXAM_TAKEN]: { color: labelColor.success, sx: commonStyleText },
    [LEARNER_PLAN_STATUS.PASSED]: { color: labelColor.lightGreen, sx: commonStyleText },
    [LEARNER_PLAN_STATUS.RETAKE_PREPARING]: { color: labelColor.disable, sx: commonStyleText },
    [LEARNER_PLAN_STATUS.FAILED_ENDED]: { color: labelColor.error, sx: commonStyleText },
  };

  const config = STATUS_CONFIG[planStatus as TLearnerPlanStatus];
  const title = LEARNER_PLAN_STATUS_LABEL[planStatus as TLearnerPlanStatus] || planStatus;

  const tagProps = useMemo<StatusConfig>(() => {
    return config ?? { color: background.disable };
  }, [config]);

  return <Tag variant={variant} {...tagProps} title={title} sx={{ ...(minWidth && { minWidth }), ...tagProps.sx }} />;
};
